/* eslint-disable import/no-anonymous-default-export */
export default {
  API: {
    AVA: {
      ADD_SITE_VIEW: "/ava/AddSiteView",
      GET_SITE_VIEW_COUNT: "/ava/GetSiteViewCount",
      SUBMIT_HELP_REQUEST: "/ava/SubmitHelpRequest",
    },
    ENROLL: {
      SUBMIT_ENROLL_REQUEST: "/enroll/SubmitEnrollRequest",
    },
    LIFEGUARD: {
      SUBMIT_LIFEGUARD_REQUEST: "/lifeguard/SubmitLifeguardRequest",
    },
    MAIL: {
      SUBMIT_CONTACT_FORM: "/mail/SubmitContactForm",
    },
    REVIEWS: {
      ADD_REVIEW: "/review/AddReview",
      GET_ALL_REVIEWS: "/review/GetAllReviews",
    },
    USERS: {
      ADD_USER: "/user/AddUser",
      CHANGE_PASSWORD: "/user/ChangePassword",
      DELETE_USER: "/user/DeleteUser",
      GENERATE_TEMPORARY_PASSWORD: "/user/GenerateTemporaryPassword",
      GET_ALL_USERS: "/user/GetAllUsers",
      GET_TOTAL_USER_COUNT: "/user/GetTotalUserCount",
      GET_USER_BY_EMAIL: "/user/GetUserByEmail",
      LOGIN: "/user/Login",
      RESET_PASSWORD: "/user/ResetPassword",
      UPDATE_USER_PROFILE: "/user/UpdateUserProfile",
    },
  },
};
